import type { PortalSiteDisplaySettingsDto } from '@supply-mover-2-0/shared';

type AuthenticatedView = PortalSiteDisplaySettingsDto['defaultAuthenticatedView'];

/**
 * Where a signed-in customer starts: the storefront's `defaultAuthenticatedView`
 * setting as a route. Shared by Home (`/`) and the `/login` address the brand's
 * website links to (PD-16862), so the two always agree on the start page.
 *
 * The API has already capability-validated the value (resolver
 * `coerceAuthenticatedView`), so it is always one the storefront can serve, and
 * no feature flag needs re-checking here. Anything unrecognized falls back to the
 * dashboard, the storefront's home.
 */
export function defaultAuthenticatedPath(
	view: AuthenticatedView | null | undefined,
): string {
	switch (view) {
		case 'browse':
			return '/catalog';
		case 'orders':
			return '/orders';
		case 'account':
			return '/account';
		case 'dashboard':
		default:
			return '/dashboard';
	}
}
